module.exports = __webpack_public_path__ + "static/img/image076.2820f1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image076.png
// module id = CbUM
// module chunks = 1